import { NgClass } from '@angular/common';
import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-multi-text-input',
  imports: [FormsModule, NgClass],
  templateUrl: './multi-text-input.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiTextInput),
      multi: true,
    },
  ],
})
export class MultiTextInput implements ControlValueAccessor {
  @Input() placeholder = 'Terminais(TID)';
  @Input() separatorKeys: string[] = [',', 'Enter', '.'];

  @ViewChild('textInput') textInput!: ElementRef;

  tags: string[] = [];
  currentInput: string = '';

  onChange = (value: string[]) => {};
  onTouched = () => {};

  handleKeydown(event: KeyboardEvent) {
    const key = event.key;

    if (this.separatorKeys.includes(key) && this.currentInput.trim()) {
      event.preventDefault();
      this.addTag(this.currentInput.trim());
      this.currentInput = '';
    }

    if (key === 'Backspace' && !this.currentInput && this.tags.length > 0) {
      this.removeTag(this.tags.length - 1);
    }
  }

  addTag(tag: string) {
    if (!this.tags.includes(tag)) {
      this.tags.push(tag);
      this.onChange(this.tags);
    }
  }

  removeTag(index: number) {
    this.tags.splice(index, 1);
    this.onChange(this.tags);
  }

  writeValue(value: string[]): void {
    this.tags = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  focusInput() {
    this.textInput.nativeElement.focus();
  }
}
